import {all, fork, takeEvery} from 'redux-saga/effects';
import {fetchTargetAgeWorker} from './targetAgeWorker';
import {GET_TARGET_AGE_OPTIONS} from '../TargetAgeAction';

export function* targetAgeWatcher() {
    yield takeEvery(GET_TARGET_AGE_OPTIONS, fetchTargetAgeWorker);
}

export default function* watchTargetAge() {
    yield all([
        fork(targetAgeWatcher),
    ])
}
